import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  EXTERNAL_LETTERS_LIST,
  EXTERNAL_LETTER_COMMENT_TEMPLATES,
  EXTERNAL_LETTER_COMMENT_TEMPLATE_CREATE,
  EXTERNAL_LETTER_COMMENT_TEMPLATE_DELETE,
  EXTERNAL_LETTER_COMPLETE,
  EXTERNAL_LETTER_COMPLETE_EXECUTION,
  EXTERNAL_LETTER_CONFIRM_INFORMED,
  EXTERNAL_LETTER_DELETE,
  EXTERNAL_LETTER_ITEM,
  EXTERNAL_LETTER_PROVIDE_RESOLUTION,
  EXTERNAL_LETTER_REQUIRE_UPDATE,
  EXTERNAL_LETTER_SEND_TO_INFORM,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const inquirySelector = (state: RootState) => prop(GLOBAL_STATE, state)

// Legacy letterIncomingSelector and letterOutgoingSelector are disabled.

export const externalLettersSelector = createSelector(inquirySelector, data => data[EXTERNAL_LETTERS_LIST])

export const externalLetterItemSelector = createSelector(inquirySelector, data => data[EXTERNAL_LETTER_ITEM])

export const externalLetterDeleteSelector = createSelector(inquirySelector, data => data[EXTERNAL_LETTER_DELETE])

export const externalLetterCommentTemplatesSelector = createSelector(
  inquirySelector,
  data => data[EXTERNAL_LETTER_COMMENT_TEMPLATES]
)

export const externalLetterCommentTemplateCreateSelector = createSelector(
  inquirySelector,
  data => data[EXTERNAL_LETTER_COMMENT_TEMPLATE_CREATE]
)

export const externalLetterCommentTemplateDeleteSelector = createSelector(
  inquirySelector,
  data => data[EXTERNAL_LETTER_COMMENT_TEMPLATE_DELETE]
)

export const externalLetterSendToInformSelector = createSelector(
  inquirySelector,
  data => data[EXTERNAL_LETTER_SEND_TO_INFORM]
)

export const externalLetterProvideResolutionSelector = createSelector(
  inquirySelector,
  data => data[EXTERNAL_LETTER_PROVIDE_RESOLUTION]
)

export const externalLetterConfirmInformedSelector = createSelector(
  inquirySelector,
  data => data[EXTERNAL_LETTER_CONFIRM_INFORMED]
)

export const externalLetterCompleteExecutionSelector = createSelector(
  inquirySelector,
  data => data[EXTERNAL_LETTER_COMPLETE_EXECUTION]
)

export const externalLetterRequireUpdateSelector = createSelector(
  inquirySelector,
  data => data[EXTERNAL_LETTER_REQUIRE_UPDATE]
)

export const externalLetterCompleteSelector = createSelector(inquirySelector, data => data[EXTERNAL_LETTER_COMPLETE])
